import {
  APP_ERROR,
  GET_ASSIGNMENT_COMPLETION_STATUSES_REQUEST,
  GET_ASSIGNMENT_COMPLETION_STATUSES_SUCCESS,
  GET_ASSIGNMENT_COMPLETION_STATUSES_ERROR,
} from '../redux/constants';
import * as lmsService from '../core/lms';

export const getAssignmentCompletionStatuses =
  (courseId, opts = {}) =>
  async (dispatch) => {
    dispatch({ type: GET_ASSIGNMENT_COMPLETION_STATUSES_REQUEST });
    const { throwException = true } = opts;
    try {
      const { assignmentCompletionStatuses } =
        await lmsService.getAssignmentCompletionStatuses(courseId);

      dispatch({
        type: GET_ASSIGNMENT_COMPLETION_STATUSES_SUCCESS,
        payload: {
          assignmentCompletionStatuses,
        },
      });
    } catch (e) {
      dispatch({ type: GET_ASSIGNMENT_COMPLETION_STATUSES_ERROR });
      dispatch({
        type: APP_ERROR,
        payload: e,
      });
      if (throwException) {
        throw e;
      }
    } finally {
      dispatch({
        type: GET_ASSIGNMENT_COMPLETION_STATUSES_REQUEST,
      });
    }
  };
